module.exports = __webpack_public_path__ + "static/project-16d-1c3343289a45cc23c0a7cc4285da3502.png";